import React from 'react';
import GongqiFormItemControl from './GongqiFormItemControl';
import FormItemPluginTree from '../FormItemPluginTree';
import FormItemPluginHtml from '../FormItemPluginHtml';
import FormItemPluginRadio from '../FormItemPluginRadio';
import FormItemPluginComment from "../FormItemPluginComment";
import FormItemPluginAttachment from "../FormItemPluginAttachment";
import FormItemUtil from '../../utils/FormItemUtil';
import FormItemConst from '../FormItemConst';

export default class FormItemPluginControl extends GongqiFormItemControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
        this.classAlias = "FormItemPluginControl";
        this.module = module;
	}

	getProperty_ControlType()
	{
		if(this.properties.hasOwnProperty("ControlType"))
			return this.properties.ControlType;
		return this.properties.PluginType;
	}

	getProperty_ClassName()
	{
		if(this.properties.hasOwnProperty("ClassName"))
			return this.properties.ClassName;
		return this.properties.Parameters;
	}
	getProperty_Visible()
	{
		if(this.properties.hasOwnProperty("Visible"))
			return this.properties.Visible;
		return this.properties.Visible;
	}
	getProperty_PlaceHolder()
	{
		if(this.properties.hasOwnProperty("PlaceHolder"))
			return this.properties.PlaceHolder;
		return this.properties.PlaceHolder;
	}

	getCommandArg()
	{
		var mi = {};
		var commandArg = CommandResolver.getSendCmd(this.module, this.group?this.group.groupAlias:null, mi);
		return commandArg;
	}
	
	getStyle()
	{
		let parentLayout = this.parentXML.Properties.Layout.Value;
		let style = {};
	   
	    if(parentLayout == "horizontal")
	    {
	    	//let json = JSON.stringify(this.props.xml.Properties.Width.Value);
	    	//alert(json);
	    	let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
	    	if(_width == undefined || _width == 0)
				_width = "";
			if(typeof(_width) == "number")_width=_width+"";
			let flexGrow = 0;
			let fixedWidth = false;
			if(_width == "")
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _width.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _width.substring(0,iex);
					style.width = _width;
				}
				
				if(iex==-1&&_width != "")
				{
					flexGrow = _width+"px";
					fixedWidth = true;
				}	
			}
			
			//style["width"] = "160px";
			if(!fixedWidth)style["flexGrow"] = flexGrow; 
			else style["width"] = flexGrow;

			let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
			if(_height == undefined)
				_height = "";
			if(_height == "")
				_height = "100%";
			if(_height == "100%")
				style["alignSelf"] = "stretch";
			else if(_height.indexOf("%") != -1)
				style["height"] = _height;
			else if(_height != "")
				style["height"] = _height+"px";
	    }
	    else //vertical 暂不考虑absolute
	    {
	    	let _height = this.getProperty_Height();//this.xml.Properties.Height.Value;
	    	if(_height==undefined || _height == 0)
				_height = "";
			if(typeof(_height) == "number")_height = _height+"";
			let flexGrow = 0;
			let fixedHeight = false;
			if(_height == "")
			{
				flexGrow = 100;
			}
			else
			{
				let iex = _height.indexOf("%");
				if(iex!=-1)
				{
					flexGrow = _height.substring(0,iex);
					style.height = _height;
				}
				if(iex==-1&&_height != "")
				{
					flexGrow = _height+"px";
					fixedHeight = true;
				}	
			}
			
			if(!fixedHeight)style["flexGrow"] = flexGrow;
			else style["height"] = flexGrow;

			let _width = this.getProperty_Width();//this.xml.Properties.Width.Value;
			if(_width == undefined)
				_width = "";
			if(_width == "")
				_width = "100%";
			if(_width == "100%")
				style["alignSelf"] = "stretch";
			else if(_width.indexOf("%") != -1)
				style["width"] = _width;
			else if(_width != "")
				style["width"] = _width+"px";
	    }
		
		return style;
	}

	isSkipTab()
	{
		let controlType = this.getProperty_ControlType();
		if(controlType == FormItemConst.PLUGIN_TYPE_RADIO)
		{
			return false;
		}
		if(controlType == FormItemConst.PLUGIN_TYPE_TREE)
		{
			return false;
		}
		return super.isSkipTab();
	}

	getComponentInstance(parent,forLookup)
	{
		let label = this.getProperty_Label();
		let layout = parent.Properties.Layout.Value;
		let commonProps = this.getCommonProps();
		let controlType = this.getProperty_ControlType();
		let controlClassName = this.getProperty_ClassName();
		if(controlType == FormItemConst.PLUGIN_TYPE_TREE)
		{
			this.component = <FormItemPluginTree key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} menuItemId = {this.menuItemId}
                label={label} formId={this.formId} group={this.group} customStyle={this.getStyle()}
                control={this} {...commonProps}/>;
		}
		else if(controlType == FormItemConst.PLUGIN_TYPE_RADIO){
			this.component = <FormItemPluginRadio key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} menuItemId = {this.menuItemId}
                label={label} formId={this.formId} group={this.group} customStyle={this.getStyle()}
                control={this} {...commonProps}/>;
		}
		else if(controlType == FormItemConst.PLUGIN_TYPE_COMMENT || controlClassName == FormItemConst.PLUGIN_TYPE_COMMENT){
			this.component = <FormItemPluginComment key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} menuItemId = {this.menuItemId}
                label={label} formId={this.formId} group={this.group} customStyle={this.getStyle()}
                control={this} {...commonProps}/>;
		}else if(controlType == FormItemConst.PLUGIN_TYPE_ATTACHMENT || controlClassName == FormItemConst.PLUGIN_TYPE_ATTACHMENT){
			this.component = <FormItemPluginAttachment key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId}  
                parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} menuItemId = {this.menuItemId}
                label={label} formId={this.formId} group={this.group} customStyle={this.getStyle()}
                control={this} {...commonProps}/>;
		}
		else
		{
			this.component = <FormItemPluginHtml key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
				parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias}
                label={label} formId={this.formId} group={this.group} customStyle={this.getStyle()}
                control={this} {...commonProps}/>;
		}
        return this.component;
	}
}


// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemPluginControl.js